import { EDIT_INITIATIVE_PRIVILEGES } from 'components/RabbitInitiativeSidePanel/accessControls/useInitiativeAccessControl';
import { intersection } from 'lodash';
import { useSelector } from 'react-redux';

import {
  CREATE_OBJECTIVE_PRIVILEGES,
  CREATE_KEY_RESULT_PRIVILEGES,
  VIEW_DOWNLOAD_INSIGHT_PRIVILEGES,
  BULK_UPLOAD_PRIVILEGES,
} from 'constants/ProjectConstants';
import { getCreatableObjectiveLevelList } from 'constants/helper';

/// // INITIATIVES

export const CREATE_INITIATIVE_PRIVILEGES = {
  CREATE_INITIATIVES: 'CREATE_INITIATIVES',
};

const selector = (state) => state.employeeGoalsAccessPrivileges;

export const useEmployeeGoalsPrivileges = () => {
  const accessPrivilegesList = useSelector(selector);

  /* View Download Insights Privileges */
  const hasViewIndividualInsightsPrivilege = accessPrivilegesList.includes(
    VIEW_DOWNLOAD_INSIGHT_PRIVILEGES.VIEW_INDIVIDUAL_INSIGHTS
  );

  const hasDownloadIndividualInsightsPrivilege = accessPrivilegesList.includes(
    VIEW_DOWNLOAD_INSIGHT_PRIVILEGES.DOWNLOAD_INDIVIDUAL_INSIGHTS
  );

  const hasViewObjectiveInsightsPrivilege = accessPrivilegesList.includes(
    VIEW_DOWNLOAD_INSIGHT_PRIVILEGES.VIEW_OBJECTIVE_LEVEL_INSIGHTS
  );

  const hasDownloadObjectiveInsightsPrivilege = accessPrivilegesList.includes(
    VIEW_DOWNLOAD_INSIGHT_PRIVILEGES.DOWNLOAD_OBJECTIVE_LEVEL_INSIGHTS
  );

  /* Bulk Upload Privileges */

  const hasBulkUploadObjectivesPrivilege = accessPrivilegesList.includes(BULK_UPLOAD_PRIVILEGES.BULK_UPLOAD_OBJECTIVES);
  const hasBulkUploadKeyResultsPrivilege = accessPrivilegesList.includes(
    BULK_UPLOAD_PRIVILEGES.BULK_UPLOAD_KEY_RESULTS
  );
  const hasBulkUploadInitiativesPrivilege = accessPrivilegesList.includes(
    BULK_UPLOAD_PRIVILEGES.BULK_UPLOAD_INITIATIVES
  );
  /* Key result helpers */

  /* if a child key result can be created. */
  const hasCreateChildKeyResultPrivilege = accessPrivilegesList.includes(
    CREATE_KEY_RESULT_PRIVILEGES.CREATE_KEY_RESULT_PARENT_MANDATORY
  );

  /* 
    if a kr can be created at root level (without parent), 
    this implicitly means canCreateChildKeyResult() is true.
  */
  const hasCreateKeyResultAtRootLevelPrivilege = accessPrivilegesList.includes(
    CREATE_KEY_RESULT_PRIVILEGES.CREATE_KEY_RESULT_PARENT_NON_MANDATORY
  );

  /* Objective Helpers */

  /* creation access for an objective */
  const hasCreateObjectivePrivilege =
    intersection(accessPrivilegesList, Object.keys(CREATE_OBJECTIVE_PRIVILEGES)).length > 0;

  /* Initiative Helpers */

  const canCreateInitiativePrivilege = accessPrivilegesList.includes(CREATE_INITIATIVE_PRIVILEGES.CREATE_INITIATIVES);

  const canEditAllInitiativePrivilege = accessPrivilegesList.includes(EDIT_INITIATIVE_PRIVILEGES.EDIT_ALL_INITIATIVE);

  const canEditPublicInitiativePrivilege =
    accessPrivilegesList.includes(EDIT_INITIATIVE_PRIVILEGES.EDIT_PUBLIC_INITIATIVE) ||
    accessPrivilegesList.includes(EDIT_INITIATIVE_PRIVILEGES.EDIT_ALL_INITIATIVE);

  /* UI specific permissions (actions common among objective and key result */

  /* 
    a user can only create an objective if he satisfies following conditions 
      - current OKR is objective and user has objective creation privilege
      - current OKR is key result and KR cascading is enabled and user has objective creation privilege 
  */
  /* const canCreateObjective =
    type === OKR_TYPES.OBJECTIVE
      ? hasCreateObjectivePrivilege
      : IS_KR_CASCADING_ENABLED && hasCreateObjectivePrivilege; */

  /* 
    a user can only create an key result if he satisfies following conditions 
      - current OKR is objective and, user has child key result creation privilege or root key result creation privilege
      - current OKR is key result and KR cascading is enabled and, user has child key result creation privilege 
        or root key result creation privilege
  */
  /* const canCreateKeyResult =
    type === OKR_TYPES.OBJECTIVE
      ? hasCreateChildKeyResultPrivilege || hasCreateKeyResultAtRootLevelPrivilege
      : IS_KR_CASCADING_ENABLED &&
        (hasCreateChildKeyResultPrivilege || hasCreateKeyResultAtRootLevelPrivilege); */

  /* other helper functions */

  const getObjectiveLevelList = () => getCreatableObjectiveLevelList(accessPrivilegesList);

  return {
    /* View Download Insights Privileges */
    hasViewIndividualInsightsPrivilege,
    hasDownloadIndividualInsightsPrivilege,
    hasViewObjectiveInsightsPrivilege,
    hasDownloadObjectiveInsightsPrivilege,

    /* Bulk Upload Privileges */
    hasBulkUploadInitiativesPrivilege,
    hasBulkUploadObjectivesPrivilege,
    hasBulkUploadKeyResultsPrivilege,

    /* Key result permissions */
    hasCreateChildKeyResultPrivilege,
    hasCreateKeyResultAtRootLevelPrivilege,

    /* Objective permissions */
    hasCreateObjectivePrivilege,

    // Initiative permissions
    canCreateInitiativePrivilege,
    canEditPublicInitiativePrivilege,
    canEditAllInitiativePrivilege,

    /* Common permissions */

    // canCreateObjective,
    // canCreateKeyResult,

    /* other helpers */
    getObjectiveLevelList,
  };
};
